import BookingForm from "../components/BookingForm";


const EmbadedForm = () => {
  return (
    <div className="flex flex-col flex justify-center md:w-1/2 md:mx-auto">
      <BookingForm formTypeProp="embadedform"/>
    </div>
  );
};

export default EmbadedForm;
